// extracted by mini-css-extract-plugin
module.exports = {"desktopContainer":"Header_desktopContainer__uozAf","mobileContainer":"Header_mobileContainer__SdHAQ"};